module.exports = __webpack_public_path__ + "img/OnMaintenance.161d387c.svg";